export default __webpack_public_path__ + "static/media/ic_moon.d808ae4a.svg";